import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import React from "react";
import styled from "styled-components";
import { color, ColorProps, position, PositionProps, space, SpaceProps, typography, TypographyProps } from "styled-system";

const Component = styled(FontAwesomeIcon)<FontAwesomeIconProps & ColorProps & PositionProps & SpaceProps & TypographyProps>`
  ${color}
  ${position}
  ${space}
  ${typography}
`;

export const Icon: React.FC<FontAwesomeIconProps & ColorProps & PositionProps & SpaceProps & TypographyProps> = props => (
  <Component {...props} />
);

Icon.defaultProps = {
  color: "primary",
  fontSize: 3,
};
